import { SC, CC } from "@bigspring/core-components";
import { Button } from "@shared/Button";

const { styled, css } = SC;

export const Section = styled(CC.Grid, SC.withTransientProps)<{
  $borderBottom?: boolean;
}>`
  display: flex;
  padding: 2px 0;
  ${({ theme, $borderBottom }) =>
    $borderBottom &&
    css`
      border-bottom: 1px solid ${theme.kinetic.v2.palette.rgb.grayUiLight};
    `};
`;
export const MenuButton = styled(Button)`
  span {
    font-size: 16px;
    line-height: 22px;
  }
`;

// icons:

export function SpringAIOutline() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.13445 9.9258C5.31054 9.96213 5.48444 10.0046 5.65595 10.053C5.80244 10.0944 5.94721 10.1401 6.0901 10.19C8.40203 10.9972 10.2213 12.9028 10.9919 15.3245C11.0396 15.4742 11.0832 15.6258 11.1227 15.7793C11.1689 15.9589 11.2094 16.1411 11.2441 16.3256C11.2495 16.3544 11.2548 16.3832 11.26 16.4122L11.2615 16.4209L11.2636 16.4328L11.277 16.5112L11.2794 16.5252C11.3325 16.8191 11.7343 16.8191 11.7874 16.5252L11.7901 16.5096L11.7986 16.4595L11.8032 16.4328L11.8053 16.4209L11.8068 16.4122C11.812 16.3832 11.8173 16.3544 11.8227 16.3256C11.8573 16.1411 11.8979 15.9589 11.9441 15.7793C11.9836 15.6258 12.0272 15.4742 12.0749 15.3245C12.8455 12.9028 14.6648 10.9972 16.9767 10.19C17.1196 10.1401 17.2643 10.0944 17.4109 10.053C17.5824 10.0046 17.7563 9.96213 17.9324 9.9258C17.9599 9.92014 17.9874 9.91461 18.015 9.90922L18.0234 9.9076L18.0347 9.90543L18.0691 9.89893L18.1095 9.89135L18.1229 9.88886C18.4035 9.83325 18.4035 9.41235 18.1229 9.35674L18.1095 9.35425L18.0347 9.34017L18.0234 9.338L18.015 9.33638C17.9874 9.33099 17.9599 9.32546 17.9324 9.31981C17.7563 9.28347 17.5824 9.24098 17.4109 9.19257C17.2643 9.15122 17.1196 9.10552 16.9767 9.05564C14.6648 8.24838 12.8455 6.34276 12.0749 3.92108C12.0272 3.77139 11.9836 3.61976 11.9441 3.46629C11.8979 3.28666 11.8573 3.10451 11.8227 2.92003C11.8173 2.89122 11.812 2.86236 11.8068 2.83344L11.8053 2.82466L11.8032 2.8128L11.7898 2.73444L11.7874 2.72044C11.7343 2.42652 11.3325 2.42652 11.2794 2.72044L11.277 2.73444L11.2768 2.7358L11.2636 2.8128L11.2615 2.82466L11.26 2.83344C11.2548 2.86236 11.2495 2.89122 11.2441 2.92003C11.2094 3.10448 11.1689 3.28666 11.1227 3.46629C11.0832 3.61976 11.0396 3.77139 10.9919 3.92108C10.2213 6.34276 8.40203 8.24838 6.0901 9.05564C5.94721 9.10552 5.80244 9.15122 5.65595 9.19257C5.48444 9.24098 5.31052 9.28347 5.13443 9.31981C5.10692 9.32546 5.07937 9.33099 5.05176 9.33638L5.04339 9.338L5.03206 9.34017L4.95725 9.35425L4.94389 9.35674C4.66329 9.41235 4.66329 9.83325 4.94389 9.88886L4.95725 9.89135L5.03206 9.90543L5.04339 9.9076L5.05176 9.90922C5.07937 9.91461 5.10692 9.92014 5.13445 9.9258Z"
        fill="white"
      />
      <path
        d="M2.61806 15.9938C2.3607 15.8531 2.08133 15.7499 1.78641 15.6909L1.74978 15.6838C1.63899 15.6631 1.63899 15.4965 1.74978 15.4759L1.78641 15.4688C2.08133 15.4098 2.3607 15.3065 2.61806 15.1658C2.73255 15.1032 2.84267 15.0332 2.94785 14.9563C3.24097 14.7423 3.49582 14.4753 3.70019 14.1683C3.77353 14.0581 3.84038 13.9427 3.90012 13.8228C4.03448 13.5533 4.13305 13.2606 4.18938 12.9517L4.19615 12.9133C4.21593 12.7973 4.37488 12.7973 4.39465 12.9133L4.4014 12.9517C4.45775 13.2606 4.55632 13.5533 4.69066 13.8228C4.75043 13.9427 4.81727 14.0581 4.89061 14.1683C5.09496 14.4753 5.34984 14.7423 5.64295 14.9563C5.74813 15.0332 5.85826 15.1032 5.97272 15.1658C6.23011 15.3065 6.50947 15.4098 6.80439 15.4688L6.841 15.4759C6.95181 15.4965 6.95181 15.6631 6.841 15.6838L6.80439 15.6909C6.50947 15.7499 6.23011 15.8531 5.97272 15.9938C5.85826 16.0564 5.74813 16.1264 5.64295 16.2033C5.34984 16.4173 5.09496 16.6843 4.89061 16.9913C4.81727 17.1015 4.75043 17.2169 4.69066 17.3368C4.55632 17.6064 4.45775 17.899 4.4014 18.2079L4.39465 18.2463C4.37488 18.3624 4.21593 18.3624 4.19615 18.2463L4.18938 18.2079C4.13305 17.899 4.03448 17.6064 3.90012 17.3368C3.84038 17.2169 3.77353 17.1015 3.70019 16.9913C3.49582 16.6843 3.24097 16.4173 2.94785 16.2033C2.84267 16.1264 2.73255 16.0564 2.61806 15.9938Z"
        fill="white"
      />
    </svg>
  );
}

export function SpringAIFilled() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.13445 9.9258C5.31054 9.96213 5.48444 10.0046 5.65595 10.053C5.80244 10.0944 5.94721 10.1401 6.0901 10.19C8.40203 10.9972 10.2213 12.9028 10.9919 15.3245C11.0396 15.4742 11.0832 15.6258 11.1227 15.7793C11.1689 15.9589 11.2094 16.1411 11.2441 16.3256C11.2495 16.3544 11.2548 16.3832 11.26 16.4122L11.2615 16.4209L11.2636 16.4328L11.277 16.5112L11.2794 16.5252C11.3325 16.8191 11.7343 16.8191 11.7874 16.5252L11.7901 16.5096L11.7986 16.4595L11.8032 16.4328L11.8053 16.4209L11.8068 16.4122C11.812 16.3832 11.8173 16.3544 11.8227 16.3256C11.8573 16.1411 11.8979 15.9589 11.9441 15.7793C11.9836 15.6258 12.0272 15.4742 12.0749 15.3245C12.8455 12.9028 14.6648 10.9972 16.9767 10.19C17.1196 10.1401 17.2643 10.0944 17.4109 10.053C17.5824 10.0046 17.7563 9.96213 17.9324 9.9258C17.9599 9.92014 17.9874 9.91461 18.015 9.90922L18.0234 9.9076L18.0347 9.90543L18.0691 9.89893L18.1095 9.89135L18.1229 9.88886C18.4035 9.83325 18.4035 9.41235 18.1229 9.35674L18.1095 9.35425L18.0347 9.34017L18.0234 9.338L18.015 9.33638C17.9874 9.33099 17.9599 9.32546 17.9324 9.31981C17.7563 9.28347 17.5824 9.24098 17.4109 9.19257C17.2643 9.15122 17.1196 9.10552 16.9767 9.05564C14.6648 8.24838 12.8455 6.34276 12.0749 3.92108C12.0272 3.77139 11.9836 3.61976 11.9441 3.46629C11.8979 3.28666 11.8573 3.10451 11.8227 2.92003C11.8173 2.89122 11.812 2.86236 11.8068 2.83344L11.8053 2.82466L11.8032 2.8128L11.7898 2.73444L11.7874 2.72044C11.7343 2.42652 11.3325 2.42652 11.2794 2.72044L11.277 2.73444L11.2768 2.7358L11.2636 2.8128L11.2615 2.82466L11.26 2.83344C11.2548 2.86236 11.2495 2.89122 11.2441 2.92003C11.2094 3.10448 11.1689 3.28666 11.1227 3.46629C11.0832 3.61976 11.0396 3.77139 10.9919 3.92108C10.2213 6.34276 8.40203 8.24838 6.0901 9.05564C5.94721 9.10552 5.80244 9.15122 5.65595 9.19257C5.48444 9.24098 5.31052 9.28347 5.13443 9.31981C5.10692 9.32546 5.07937 9.33099 5.05176 9.33638L5.04339 9.338L5.03206 9.34017L4.95725 9.35425L4.94389 9.35674C4.66329 9.41235 4.66329 9.83325 4.94389 9.88886L4.95725 9.89135L5.03206 9.90543L5.04339 9.9076L5.05176 9.90922C5.07937 9.91461 5.10692 9.92014 5.13445 9.9258Z"
        fill="#313130"
      />
      <path
        d="M2.61806 15.9938C2.3607 15.8531 2.08133 15.7499 1.78641 15.6909L1.74978 15.6838C1.63899 15.6631 1.63899 15.4965 1.74978 15.4759L1.78641 15.4688C2.08133 15.4098 2.3607 15.3065 2.61806 15.1658C2.73255 15.1032 2.84267 15.0332 2.94785 14.9563C3.24097 14.7423 3.49582 14.4753 3.70019 14.1683C3.77353 14.0581 3.84038 13.9427 3.90012 13.8228C4.03448 13.5533 4.13305 13.2606 4.18938 12.9517L4.19615 12.9133C4.21593 12.7973 4.37488 12.7973 4.39465 12.9133L4.4014 12.9517C4.45775 13.2606 4.55632 13.5533 4.69066 13.8228C4.75043 13.9427 4.81727 14.0581 4.89061 14.1683C5.09496 14.4753 5.34984 14.7423 5.64295 14.9563C5.74813 15.0332 5.85826 15.1032 5.97272 15.1658C6.23011 15.3065 6.50947 15.4098 6.80439 15.4688L6.841 15.4759C6.95181 15.4965 6.95181 15.6631 6.841 15.6838L6.80439 15.6909C6.50947 15.7499 6.23011 15.8531 5.97272 15.9938C5.85826 16.0564 5.74813 16.1264 5.64295 16.2033C5.34984 16.4173 5.09496 16.6843 4.89061 16.9913C4.81727 17.1015 4.75043 17.2169 4.69066 17.3368C4.55632 17.6064 4.45775 17.899 4.4014 18.2079L4.39465 18.2463C4.37488 18.3624 4.21593 18.3624 4.19615 18.2463L4.18938 18.2079C4.13305 17.899 4.03448 17.6064 3.90012 17.3368C3.84038 17.2169 3.77353 17.1015 3.70019 16.9913C3.49582 16.6843 3.24097 16.4173 2.94785 16.2033C2.84267 16.1264 2.73255 16.0564 2.61806 15.9938Z"
        fill="#313130"
      />
    </svg>
  );
}

export function RepsIcons() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5448_1037)">
        <path
          d="M15.8333 2.5H4.16667C3.25 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 14.8333C15.8333 15.3856 15.3856 15.8333 14.8333 15.8333H5.16667C4.61438 15.8333 4.16667 15.3856 4.16667 14.8333V5.16667C4.16667 4.61438 4.61438 4.16667 5.16667 4.16667H14.8333C15.3856 4.16667 15.8333 4.61438 15.8333 5.16667V14.8333ZM5.83333 8.33333H7.5V14.1667H5.83333V8.33333ZM9.16667 5.83333H10.8333V14.1667H9.16667V5.83333ZM12.5 10.8333H14.1667V14.1667H12.5V10.8333Z"
          fill="#313130"
        />
      </g>
      <defs>
        <clipPath id="clip0_5448_1037">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PlaysIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5448_1715)">
        <path
          d="M3.33335 5.83329C3.33335 5.37306 3.70645 4.99996 4.16669 4.99996H15.8334C16.2936 4.99996 16.6667 5.37306 16.6667 5.83329V6.66663H3.33335V5.83329ZM5.00002 2.49996C5.00002 2.03972 5.37312 1.66663 5.83335 1.66663H14.1667C14.6269 1.66663 15 2.03972 15 2.49996V3.33329H5.00002V2.49996ZM16.6667 8.33329H3.33335C2.41669 8.33329 1.66669 9.08329 1.66669 9.99996V16.6666C1.66669 17.5833 2.41669 18.3333 3.33335 18.3333H16.6667C17.5834 18.3333 18.3334 17.5833 18.3334 16.6666V9.99996C18.3334 9.08329 17.5834 8.33329 16.6667 8.33329ZM16.6667 15.8333C16.6667 16.2935 16.2936 16.6666 15.8334 16.6666H4.16669C3.70645 16.6666 3.33335 16.2935 3.33335 15.8333V10.8333C3.33335 10.3731 3.70645 9.99996 4.16669 9.99996H15.8334C16.2936 9.99996 16.6667 10.3731 16.6667 10.8333V15.8333Z"
          fill="#313130"
        />
        <path
          d="M8.33335 10.8333V15.8333L12.5 13.3333L8.33335 10.8333Z"
          fill="#313130"
        />
      </g>
      <defs>
        <clipPath id="clip0_5448_1715">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PeopleIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5448_288"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="white" />
      </mask>
      <g mask="url(#mask0_5448_288)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 15V13.6875C0 13.0764 0.309167 12.5867 0.9275 12.2183C1.54528 11.8506 2.34722 11.6667 3.33333 11.6667C3.51389 11.6667 3.6875 11.67 3.85417 11.6767C4.02083 11.6839 4.18056 11.7014 4.33333 11.7292C4.13889 12.0069 3.99306 12.3056 3.89583 12.625C3.79861 12.9444 3.75 13.2847 3.75 13.6458V15H0ZM5 15V13.6458C5 12.7431 5.46194 12.0139 6.38583 11.4583C7.30917 10.9028 8.51389 10.625 10 10.625C11.5 10.625 12.7083 10.9028 13.625 11.4583C14.5417 12.0139 15 12.7431 15 13.6458V15H5ZM16.25 15V13.6458C16.25 13.2847 16.2047 12.9444 16.1142 12.625C16.0242 12.3056 15.8889 12.0069 15.7083 11.7292C15.8611 11.7014 16.0175 11.6839 16.1775 11.6767C16.3369 11.67 16.5 11.6667 16.6667 11.6667C17.6667 11.6667 18.4722 11.8506 19.0833 12.2183C19.6944 12.5867 20 13.0764 20 13.6875V15H16.25ZM10 12.2917C9.20833 12.2917 8.5 12.3958 7.875 12.6042C7.25 12.8125 6.88194 13.0556 6.77083 13.3333H13.25C13.125 13.0556 12.7533 12.8125 12.135 12.6042C11.5172 12.3958 10.8056 12.2917 10 12.2917ZM3.33333 10.8333C2.875 10.8333 2.48278 10.67 2.15667 10.3433C1.83 10.0172 1.66667 9.625 1.66667 9.16667C1.66667 8.69444 1.83 8.29861 2.15667 7.97917C2.48278 7.65972 2.875 7.5 3.33333 7.5C3.80556 7.5 4.20139 7.65972 4.52083 7.97917C4.84028 8.29861 5 8.69444 5 9.16667C5 9.625 4.84028 10.0172 4.52083 10.3433C4.20139 10.67 3.80556 10.8333 3.33333 10.8333ZM16.6667 10.8333C16.2083 10.8333 15.8158 10.67 15.4892 10.3433C15.1631 10.0172 15 9.625 15 9.16667C15 8.69444 15.1631 8.29861 15.4892 7.97917C15.8158 7.65972 16.2083 7.5 16.6667 7.5C17.1389 7.5 17.5347 7.65972 17.8542 7.97917C18.1736 8.29861 18.3333 8.69444 18.3333 9.16667C18.3333 9.625 18.1736 10.0172 17.8542 10.3433C17.5347 10.67 17.1389 10.8333 16.6667 10.8333ZM10 10C9.30556 10 8.71528 9.75694 8.22917 9.27083C7.74306 8.78472 7.5 8.19444 7.5 7.5C7.5 6.79167 7.74306 6.19778 8.22917 5.71833C8.71528 5.23944 9.30556 5 10 5C10.7083 5 11.3019 5.23944 11.7808 5.71833C12.2603 6.19778 12.5 6.79167 12.5 7.5C12.5 8.19444 12.2603 8.78472 11.7808 9.27083C11.3019 9.75694 10.7083 10 10 10ZM10 6.66667C9.76389 6.66667 9.56611 6.74639 9.40667 6.90583C9.24667 7.06583 9.16667 7.26389 9.16667 7.5C9.16667 7.73611 9.24667 7.93389 9.40667 8.09333C9.56611 8.25333 9.76389 8.33333 10 8.33333C10.2361 8.33333 10.4342 8.25333 10.5942 8.09333C10.7536 7.93389 10.8333 7.73611 10.8333 7.5C10.8333 7.26389 10.7536 7.06583 10.5942 6.90583C10.4342 6.74639 10.2361 6.66667 10 6.66667ZM3.75 9.16667C3.75 9.39679 3.56345 9.58333 3.33333 9.58333C3.10321 9.58333 2.91667 9.39679 2.91667 9.16667C2.91667 8.93655 3.10321 8.75 3.33333 8.75C3.56345 8.75 3.75 8.93655 3.75 9.16667ZM16.6667 9.58333C16.8968 9.58333 17.0833 9.39679 17.0833 9.16667C17.0833 8.93655 16.8968 8.75 16.6667 8.75C16.4365 8.75 16.25 8.93655 16.25 9.16667C16.25 9.39679 16.4365 9.58333 16.6667 9.58333Z"
          fill="#313130"
        />
      </g>
    </svg>
  );
}

export function IntegrationsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 15.8333H13.3333V12.5H11.1C10.15 14.5166 8.1 15.8333 5.83333 15.8333C2.61667 15.8333 0 13.2166 0 9.99996C0 6.78329 2.61667 4.16663 5.83333 4.16663C8.1 4.16663 10.1417 5.48329 11.1 7.49996H20V12.5H18.3333V15.8333ZM15 14.1666H16.6667V10.8333H18.3333V9.16663H9.95L9.75833 8.60829C9.175 6.94996 7.59167 5.83329 5.83333 5.83329C3.53333 5.83329 1.66667 7.69996 1.66667 9.99996C1.66667 12.3 3.53333 14.1666 5.83333 14.1666C7.59167 14.1666 9.175 13.05 9.75833 11.3916L9.95 10.8333H15V14.1666ZM5.83333 12.5C4.45833 12.5 3.33333 11.375 3.33333 9.99996C3.33333 8.62496 4.45833 7.49996 5.83333 7.49996C7.20833 7.49996 8.33333 8.62496 8.33333 9.99996C8.33333 11.375 7.20833 12.5 5.83333 12.5ZM5.83333 9.16663C5.375 9.16663 5 9.54163 5 9.99996C5 10.4583 5.375 10.8333 5.83333 10.8333C6.29167 10.8333 6.66667 10.4583 6.66667 9.99996C6.66667 9.54163 6.29167 9.16663 5.83333 9.16663Z"
        fill="#313130"
      />
    </svg>
  );
}

export function SuperAdminIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5448_510)">
        <path
          d="M2.5 2.5V9.16667H9.16667V2.5H2.5ZM7.5 7.5H4.16667V4.16667H7.5V7.5ZM2.5 10.8333V17.5H9.16667V10.8333H2.5ZM7.5 15.8333H4.16667V12.5H7.5V15.8333ZM10.8333 2.5V9.16667H17.5V2.5H10.8333ZM15.8333 7.5H12.5V4.16667H15.8333V7.5ZM10.8333 10.8333V17.5H17.5V10.8333H10.8333ZM15.8333 15.8333H12.5V12.5H15.8333V15.8333Z"
          fill="#313130"
        />
      </g>
      <defs>
        <clipPath id="clip0_5448_510">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ExchangeIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5448_1584)">
        <path
          d="M18.3333 6.66668L15 3.33334V5.83334H2.5V7.50001H15V10L18.3333 6.66668Z"
          fill="#313130"
        />
        <path
          d="M1.66663 13.3333L4.99996 16.6667V14.1667H17.5V12.5H4.99996V10L1.66663 13.3333Z"
          fill="#313130"
        />
      </g>
      <defs>
        <clipPath id="clip0_5448_1584">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function AppIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 3.5C4.725 3.5 4.5 3.725 4.5 4V16C4.5 16.275 4.725 16.5 5 16.5H15C15.275 16.5 15.5 16.275 15.5 16V4C15.5 3.725 15.275 3.5 15 3.5H5ZM3 4C3 2.89688 3.89688 2 5 2H15C16.1031 2 17 2.89688 17 4V16C17 17.1031 16.1031 18 15 18H5C3.89688 18 3 17.1031 3 16V4ZM10 13.25C10.5531 13.25 11 13.6969 11 14.25C11 14.8031 10.5531 15.25 10 15.25C9.44688 15.25 9 14.8031 9 14.25C9 13.6969 9.44688 13.25 10 13.25Z"
        fill="#8F8F8F"
      />
    </svg>
  );
}
